"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveProjectParticipantModalComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const promiseUtils_1 = require("src/configeek_assets/src/system/mics/promiseUtils");
const ICCanisterUtils_1 = require("src/configeek_assets/src/ic/ICCanisterUtils");
const TextTruncated_1 = require("src/configeek_assets/src/components/common/widget/TextTruncated");
const ProjectParticipantsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectParticipantsDataProvider");
const i18_1 = require("src/configeek_assets/src/i18");
const modalButtonsPropsInitialValue = {
    ok: { disabled: false, danger: true },
    cancel: {}
};
const RemoveProjectParticipantModalComponent = (props) => {
    var _a;
    const participantsDataContext = (0, ProjectParticipantsDataProvider_1.useProjectParticipantsDataContext)();
    const [deleteError, setDeleteError] = (0, react_1.useState)(undefined);
    const [modalButtonProps, setModalButtonProps] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), modalButtonsPropsInitialValue);
    const title = "Remove member";
    const okText = "Remove";
    const errorText = i18_1.i18.project.members.error.modal.remove;
    const removeCancellable = (0, react_1.useMemo)(() => (0, promiseUtils_1.makeCancelableAsync)(async (principal) => {
        const removeParticipantResult = await participantsDataContext.removeParticipant(principal);
        if (removeParticipantResult.status === "success") {
            participantsDataContext.fetchParticipants();
        }
        return removeParticipantResult;
    }), [participantsDataContext.removeParticipant]);
    const asyncRemove = async () => {
        try {
            //disabled buttons
            setModalButtonProps({
                ok: { disabled: true, loading: true, },
                cancel: { disabled: true, }
            });
            if (props.participantView == undefined) {
                // noinspection ExceptionCaughtLocallyJS
                throw new Error("No Participant");
            }
            const result = await removeCancellable.run(props.participantView.principal);
            switch (result.state) {
                case "success": {
                    const removeParticipantResult = result.result;
                    if (!!process.env.IS_TEST_SERVER) {
                        console.log("asyncRemove removeCancellable result", removeParticipantResult);
                    }
                    switch (removeParticipantResult.status) {
                        case "success": {
                            props.onDestroy();
                            break;
                        }
                        case "error": {
                            // const reason = removeParticipantResult.reason;
                            //enabled buttons
                            setModalButtonProps({
                                ok: { disabled: false, loading: false, },
                                cancel: { disabled: false, }
                            });
                            setDeleteError(errorText);
                            break;
                        }
                        case "unknownError": {
                            // noinspection ExceptionCaughtLocallyJS
                            throw removeParticipantResult.error;
                        }
                    }
                    break;
                }
                case "cancelled": {
                    //skip
                    break;
                }
                case "error": {
                    // noinspection ExceptionCaughtLocallyJS
                    throw result.error;
                }
            }
        }
        catch (e) {
            console.error("RemoveProjectParticipantModalComponent: removeParticipant caught error", e);
            const error = ICCanisterUtils_1.ICRestError.withUnknownError(e);
            //enabled buttons
            setModalButtonProps({
                ok: { disabled: false, loading: false, },
                cancel: { disabled: false, }
            });
            //update errors
            setDeleteError(errorText);
        }
    };
    const onCancel = () => {
        props.onDestroy();
    };
    const onOk = async () => {
        await asyncRemove();
    };
    return React.createElement(antd_1.Modal, { width: 550, closable: false, maskClosable: false, destroyOnClose: true, visible: props.visible, title: title, onCancel: onCancel, okText: okText, onOk: onOk, okButtonProps: modalButtonProps.ok, cancelButtonProps: modalButtonProps.cancel, className: "ug-modal" },
        deleteError && React.createElement(antd_1.Alert, { message: deleteError, type: "error" }),
        "Are you sure you want to remove \"",
        React.createElement(TextTruncated_1.TextTruncated, { text: ((_a = props.participantView) === null || _a === void 0 ? void 0 : _a.name) || "", length: 40 }),
        "\" from \"",
        React.createElement(TextTruncated_1.TextTruncated, { text: props.projectView.projectName, length: 40 }),
        "\"?");
};
exports.RemoveProjectParticipantModalComponent = RemoveProjectParticipantModalComponent;
